/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import mbpLogger from 'mbp-logger';
import restClient from '../../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

const getUserRegisteredStatus = async (payload) => {
    const jwtToken = await getAccessTokenSafely();
    const wcEnv = {
        rootUri: '/',
    };

    const resourcePage = `profile/auth0/checkuser`;

    try {
        const response = await restClient.postFacade(wcEnv, resourcePage, jwtToken, payload)
        return response;
    } catch (err) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: err,
            message: 'getUserRegisteredStatus: Error while fetching user details.',
        });
    }
}

export default getUserRegisteredStatus;
